import { ButtonList } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';
import { Channel } from 'lib-shared-types-channels';
import { useState } from 'react';

import { UnbanUserModal } from 'components/shared/unbanUserModal/unbanUserModal';
import { channelAttributes } from 'utils/channels';

export function UnbanUserButtonListItem(props: {
  user: User;
  channel: Channel;
  onModalOpen?: VoidFunction;
  onUnban?: VoidFunction;
}): JSX.Element {
  const [isModalOpen, setModalOpen] = useState(false);
  const { user, channel, onUnban, onModalOpen } = props;

  function handleOnModalClose(canceled) {
    setModalOpen(false);

    if (!canceled) {
      onUnban?.();
    }
  }

  function handleOnModalOpen() {
    setModalOpen(true);
    onModalOpen && onModalOpen();
  }

  return (
    <>
      <ButtonList.Item icon="undo" onClick={handleOnModalOpen}>
        Unban from {channelAttributes[channel]?.name ?? 'Unknown'}
      </ButtonList.Item>
      <UnbanUserModal
        user={user}
        channel={channel}
        isOpen={isModalOpen}
        onClose={handleOnModalClose}
      />
    </>
  );
}
